var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import clsx from 'clsx';
import { Text } from '@patternfly/react-core';
import { createUseStyles } from 'react-jss';
const useStyles = createUseStyles({
    errorStack: {
        fontFamily: 'monospace',
        fontSize: 'var(--pf-v5-global--icon--FontSize--md)',
        textAlign: 'left',
        backgroundColor: 'white',
        borderStyle: 'solid',
        borderColor: 'var(--pf-v5-global--BackgroundColor--dark-300)',
        overflowWrap: 'break-word',
        padding: 'var(--pf-v5-global--spacer--sm)'
    },
});
export const ErrorStack = (_a) => {
    var { error, className } = _a, props = __rest(_a, ["error", "className"]);
    const classes = useStyles();
    if (error.stack) {
        return (React.createElement(Text, Object.assign({ className: clsx(classes.errorStack, className) }, props), error.stack.split('\n').map((line) => (React.createElement("div", { key: line }, line)))));
    }
    if (error.name && error.message) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Text, { component: "h6" }, error.name),
            React.createElement(Text, Object.assign({ className: clsx(classes.errorStack, className), component: "blockquote" }, props), error.message)));
    }
    return (React.createElement(Text, { className: classes.errorStack, component: "blockquote" }, error.toString()));
};
export default ErrorStack;
